import { createSelector } from 'reselect';

export const selectorMunicipis = state => state.municipis.tots;
export const selectorObtenirMunicipisEnCurs = state => state.municipis.peticioObtenirMunicipisEnCurs;

const obtenirMunicipisAmbCoordenadesIComarca = (municipis) => {

    if (!municipis) {
        return null;
    }

    var municipisAmbCoordenadesIComarca = {};

    Object.keys(municipis).forEach((ineMunicipi) => {
        const municipi = municipis[ineMunicipi];
        if (municipi.coordenades && municipi.comarca) {
            municipisAmbCoordenadesIComarca[ineMunicipi] = municipi;
        }
    });

    return municipisAmbCoordenadesIComarca;
};

export const selectorMunicipisAmbCoordenadesIComarca = createSelector(
    selectorMunicipis,
    obtenirMunicipisAmbCoordenadesIComarca
);


// WEBPACK FOOTER //
// ./src/selectors/selector_municipis.js